<template>
  <div>
    <div class="es-op-box">
      <el-input placeholder="线路名称" v-model="queryObj.lineName" size="small" class="query" style="float: left" clearable
        @change="
          () => {
            this.queryObj.pageNum = 1;
            init();
          }
        ">
        <i slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="primary" icon="el-icon-font el-icon-web__tianjia" size="mini" style="margin-right: 6px"
        @click="add_init">新增</el-button>
      <es-delete @del="del()" type="button"></es-delete>
    </div>
    <el-table :data="pageData.list" ref="inslinetimeTable" border stripe size="mini" height="calc(100vh - 180px)"
      v-loading="loading">
      <el-table-column type="selection" width="40" align="center">
      </el-table-column>
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="lineName" label="线路名称"> </el-table-column>
      <el-table-column prop="startday" label="生效时间">
        <template slot-scope="scope">
          <span>{{ scope.row.startday.substring(0, 10) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="endday" label="失效时间">
        <template slot-scope="scope">
          <span>{{ scope.row.endday.substring(0, 10) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-link :underline="false" title="编辑" @click="edit_init(scope.row)" type="primary"><i
              class="el-icon-font el-icon-bianji"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete @del="del(scope.row.id)" :key="scope.row.id" type="icon"></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination :data="pageData" width="1000px" @change="
        (cpage) => {
          this.queryObj.pageNum = cpage;
          this.loadInsLineTimeList();
        }
      ">
      </es-pagination>
    </div>
    <!--编辑线路时间规则-->
    <el-dialog :visible.sync="editVisible" @closed="
      () => {
        this.$refs['inslinetimeeditForm'].clearValidate();
        this.insLineTimeInfo = {};
        this.timeVisible = false;
      }
    " width="900px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑线路时间规则
      </span>
      <el-form :model="insLineTimeInfo" :rules="rulesEdit" size="mini" label-position="right" label-width="110px"
        ref="inslinetimeeditForm" inline-message: true>
        <el-form-item prop="lineId" label="线路名称">
          <el-select ref="factorySelect" style="width: 200px" size="mini" v-model="insLineTimeInfo.lineId"
            placeholder="请选择线路名称" clearable filterable>
            <el-option v-for="item in lineListOptions" :key="item.id" :label="item.name" :value="item.id"
              @click.native="getValue(item.name)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="dateTime" label="生效日期">
          <el-date-picker style="width: 200px" value-format="yyyy-MM-dd" v-model="insLineTimeInfo.dateTime"
            type="daterange" range-separator="至" start-placeholder="生效开始日期" end-placeholder="生效结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="type" label="类型">
          <el-radio-group v-model="insLineTimeInfo.type" @change="ontypeChange()">
            <el-radio :label="1">日</el-radio>
            <el-radio :label="2">月</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="never" label="频率">
          <el-input-number v-model="insLineTimeInfo.never" :min="1" :max="100" placeholder="频率" style="width: 200px"
            clearable @change="handleNumChange"></el-input-number>
        </el-form-item>

        <el-row :gutter="15">
          <el-col :span="1">
            <el-form-item>
              <el-link :underline="false" title="添加" style="margin-left: -51px" type="primary"
                @click="selecDateAndTime()"><i class="el-icon-circle-plus"></i></el-link>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="
            timeVisible &&
            this.insLineTimeInfo.type == 1 &&
            this.insLineTimeInfo.never != ''
          ">
            <el-form-item prop="start_day_num" style="margin-left: -37px">
              <el-select v-model="insLineTimeInfo.start_day_num" placeholder="天" style="width: 90px" popper-append-to-body
                clearable @change="listenDay()">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
                  @click.native="getStartDayValue(item.value)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="
            timeVisible &&
            this.insLineTimeInfo.type == 1 &&
            this.insLineTimeInfo.never != ''
          ">
            <el-form-item prop="starttime" style="margin-left: -120px">
              <el-time-select placeholder="开始时间" style="width: 110px" v-model="insLineTimeInfo.starttime" :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '23:59',
              }">
              </el-time-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="
            timeVisible &&
            this.insLineTimeInfo.type == 1 &&
            this.insLineTimeInfo.never != ''
          ">
            <el-form-item prop="end_day_num" style="margin-left: -218px">
              <el-select v-model="insLineTimeInfo.end_day_num" placeholder="天" style="width: 90px" popper-append-to-body
                clearable>
                <el-option v-for="option in filteredOptions" :key="option.value" :label="option.label"
                  :value="option.value" :disabled="option.disabled"
                  @click.native="getEndDayValue(option.value)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="
            timeVisible &&
            this.insLineTimeInfo.type == 1 &&
            this.insLineTimeInfo.never != ''
          ">
            <el-form-item prop="endtime" style="margin-left: -300px">
              <el-time-select placeholder="结束时间" style="width: 110px" v-model="insLineTimeInfo.endtime" :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '23:59',
                minTime: insLineTimeInfo.starttime,
              }">
              </el-time-select>
            </el-form-item>
          </el-col>
          <el-col :span="1" v-if="
            timeVisible &&
            this.insLineTimeInfo.type == 1 &&
            this.insLineTimeInfo.never != ''
          ">
            <el-form-item style="width: 100%">
              <el-link :underline="false" title="添加" style="margin-left: -380px" type="success" @click="onSubmitDetail"><i
                  class="el-icon-success"></i></el-link>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="
            timeVisible &&
            this.insLineTimeInfo.type == 2 &&
            this.insLineTimeInfo.never != ''
          ">
            <el-form-item prop="start_month_num" style="margin-left: -37px">
              <el-select v-model="insLineTimeInfo.start_month_num" placeholder="月" :style="{ width: '90px' }" clearable
                popper-append-to-body @change="listenMonth()">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
                  @click.native="getStartMonthValue(item.value)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="
            timeVisible &&
            this.insLineTimeInfo.type == 2 &&
            this.insLineTimeInfo.never != ''
          ">
            <el-form-item prop="start_day_num" style="margin-left: -150px">
              <el-select v-model="insLineTimeInfo.start_day_num" placeholder="天" :style="{ width: '90px' }" clearable
                popper-append-to-body @change="listenDay()">
                <el-option v-for="item in optionsday" :key="item.value" :label="item.label" :value="item.value"
                  @click.native="getStartDayValue(item.value)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11" v-if="
            timeVisible &&
            this.insLineTimeInfo.type == 2 &&
            this.insLineTimeInfo.never != ''
          ">
            <el-form-item prop="starttime" style="margin-left: -265px">
              <el-time-select placeholder="开始时间" style="width: 110px" v-model="insLineTimeInfo.starttime" :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '23:59',
              }">
              </el-time-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="6" v-if="
            timeVisible &&
            this.insLineTimeInfo.type == 2 &&
            this.insLineTimeInfo.never != ''
          ">
            <el-form-item prop="end_month_num">
              <el-select v-model="insLineTimeInfo.end_month_num" placeholder="月" :style="{ width: '90px' }" clearable
                popper-append-to-body>
                <el-option v-for="option in filteredOptions" :key="option.value" :label="option.label"
                  :value="option.value" :disabled="option.disabled"
                  @click.native="getEndMonthValue(option.value)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="
            timeVisible &&
            this.insLineTimeInfo.type == 2 &&
            this.insLineTimeInfo.never != ''
          ">
            <el-form-item prop="end_day_num" style="margin-left: -113px">
              <el-select v-model="insLineTimeInfo.end_day_num" placeholder="天" :style="{ width: '90px' }" clearable
                popper-append-to-body>
                <el-option v-for="option in filteredOptionsDay" :key="option.value" :label="option.label"
                  :value="option.value" :disabled="option.disabled"
                  @click.native="getEndDayValue(option.value)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11" v-if="
            timeVisible &&
            this.insLineTimeInfo.type == 2 &&
            this.insLineTimeInfo.never != ''
          ">
            <el-form-item prop="endtime" style="margin-left: -228px">
              <el-time-select placeholder="结束时间" style="width: 110px" v-model="insLineTimeInfo.endtime" :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '23:59',
                minTime: insLineTimeInfo.starttime,
              }">
              </el-time-select>
            </el-form-item>
          </el-col>
          <el-col :span="1" v-if="
            timeVisible &&
            this.insLineTimeInfo.type == 2 &&
            this.insLineTimeInfo.never != ''
          ">
            <el-form-item style="width: 100%">
              <el-link :underline="false" title="添加" style="margin-left: -500px" type="success" @click="onSubmitDetail"><i
                  class="el-icon-success"></i></el-link>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="detailList">
          <el-table :data="insLineTimeInfo.detailList" ref="inslinetimeDetailTable" border
            style="margin-left: -60px; width: 100%; overflow-y: auto;" stripe size="mini">
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="startMonthNum" label="开始月">
            </el-table-column>
            <el-table-column prop="startDayNum" label="开始日">
              <template slot-scope="scope">
                <span>{{ scope.row.startDayNum != null && scope.row.startDayNum == 32 ? "月底" : scope.row.startDayNum
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="starttime" label="开始时间">
            </el-table-column>
            <el-table-column prop="endMonthNum" label="结束月">
            </el-table-column>
            <el-table-column prop="endDayNum" label="结束日">
              <template slot-scope="scope">
                <span>{{ scope.row.endDayNum != null && scope.row.endDayNum == 32 ? "月底" : scope.row.endDayNum }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="endtime" label="结束时间"> </el-table-column>
            <el-table-column label="操作" width="50" align="center">
              <template slot-scope="scope">
                <es-delete @del="delDetailList(scope)" :key="scope.row.id" type="icon"></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <!-- </div> -->
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="
          () => {
            this.editVisible = false;
            this.insLineTimeInfo = {};
            this.timeVisible = false;
            this.options = [];
            this.optionsday = [];
          }
        ">取 消</el-button>
        <el-button type="primary" size="mini" @click="submitEditLineTime()" :loading="savingEdit">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "inslinetime",
  props: ["funcs"],
  data () {
    return {
      options: [],
      optionsday: [],
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      lineListOptions: [],
      insLineTimeInfo: {}, //系统信息
      rulesEdit: {
        //验证条件
        dateTime: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        starttime: [
          { required: true, message: "请选择时间", trigger: "change" },
        ],
        endtime: [{ required: true, message: "请选择时间", trigger: "change" }],
        lineId: [{ required: true, message: "请选择线路", trigger: "blur" }],
        never: [{ required: true, message: "请填写频率", trigger: "change" }],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
        start_day_num: [
          { required: true, message: "请选择开始天数", trigger: "blur" },
        ],
        end_day_num: [
          { required: true, message: "请选择结束天数", trigger: "blur" },
        ],
        start_month_num: [
          { required: true, message: "请选择开始月数", trigger: "blur" },
        ],
        end_month_num: [
          { required: true, message: "请选择结束月数", trigger: "blur" },
        ],
      },
      loading: false,
      saving: false,
      savingEdit: false,
      editVisible: false,
      createVisible: false,
      timeVisible: false,
    };
  },
  methods: {
    //页面初始化
    init () {
      this.loadInsLineTimeList();
    },
    //从后台查询线路时间规则列表
    loadInsLineTimeList () {
      this.loading = true;
      this.$ajax
        .get("/buss/insLineTime/listLineTime", this.queryObj)
        .then((msg) => {
          this.pageData = msg;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    //从后台查询线路时间规则列表
    loadLineListAll () {
      this.loading = true;
      this.$ajax
        .get("/buss/line/linelist_all", this.queryObj)
        .then((msg) => {
          console.log(msg);
          this.lineListOptions = msg;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    //初始化添加线路时间规则
    add_init () {
      this.insLineTimeInfo = {};
      this.$set(this.insLineTimeInfo, "type", 1);
      this.editVisible = true;
    },
    //获取线路名称
    getValue (val) {
      this.insLineTimeInfo.lineName = val;
      this.$refs["inslinetimeeditForm"].clearValidate();
    },
    //初始化知识库
    edit_init (row) {
      this.insLineTimeInfo = {};
      this.getLineTimeById(row);
      this.editVisible = true;
    },
    getLineTimeById (val) {
      let id = val.id;
      if (id != null) {
        this.loading = true;
        this.$ajax
          .get("/buss/insLineTime/getLineTimeById", { id: id })
          .then((msg) => {
            if (msg.startday != null && msg.endday != null) {
              msg.dateTime = [new Date(msg.startday), new Date(msg.endday)];
            }
            this.insLineTimeInfo = msg;
            this.$set(this.insLineTimeInfo, "type", this.insLineTimeInfo.type);
            this.loading = false;
            this.options = []
            for (let i = 0; i < this.insLineTimeInfo.never; i++) {
              const obj = {
                label: i + 1,
                value: i + 1,

              };
              this.options.push(obj);
              if (this.insLineTimeInfo.type == 2) {
                this.optionsday = []
                for (let i = 0; i < 28; i++) {
                  const obj = {
                    label: i + 1,
                    value: i + 1,
                  };
                  this.optionsday.push(obj);
                }
                const obj = {
                  label: "月底",
                  value: 32,
                };
                this.optionsday.push(obj);
              }
            }
            console.log("insLineTimeInfo", this.insLineTimeInfo);
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    onSubmitDetail () {
      let validateFieldList = [];
      this.$refs["inslinetimeeditForm"].validateField(
        [
          "starttime",
          "endtime",
          "start_day_num",
          "end_day_num",
          "start_month_num",
          "end_month_num",
        ],

        async (errorMsg) => {
          if (this.insLineTimeInfo.type == 1) {
            if (!errorMsg) {
              validateFieldList.push(errorMsg);
              if (
                validateFieldList.length == 4 &&
                validateFieldList.every((item) => item === "")
              ) {
                let arr = this.insLineTimeInfo.detailList;
                if (arr == null) {
                  arr = new Array();
                }
                if (this.insLineTimeInfo.never > 1 && arr.length > 0) {
                  this.$message.error("请重新选择频率");
                  this.insLineTimeInfo.start_day_num = "";
                  this.insLineTimeInfo.end_day_num = "";
                  this.insLineTimeInfo.starttime = "";
                  this.insLineTimeInfo.endtime = "";
                  this.timeVisible = false;
                  return;
                }
                let po = new Object();
                po.timeId = this.insLineTimeInfo.id;
                po.startDayNum = this.insLineTimeInfo.start_day_num;
                po.endDayNum = this.insLineTimeInfo.end_day_num;
                po.starttime = this.insLineTimeInfo.starttime;
                po.endtime = this.insLineTimeInfo.endtime;
                arr.push(po);
                this.insLineTimeInfo.detailList = arr;
                this.insLineTimeInfo.starttime = "";
                this.insLineTimeInfo.endtime = "";
                this.timeVisible = false;
                this.insLineTimeInfo.start_day_num = "";
                this.insLineTimeInfo.end_day_num = "";
              }
            } else {
              console.log("error 1!!");
              return false;
            }
          } else if (this.insLineTimeInfo.type == 2) {
            if (!errorMsg) {
              validateFieldList.push(errorMsg);
              if (
                validateFieldList.length == 6 &&
                validateFieldList.every((item) => item === "")
              ) {
                let arr = this.insLineTimeInfo.detailList;
                if (arr == null) {
                  arr = new Array();
                }
                if (this.insLineTimeInfo.never > 1 && arr.length > 0) {
                  this.$message.error("请重新选择频率");
                  this.insLineTimeInfo.start_day_num = "";
                  this.insLineTimeInfo.end_day_num = "";
                  this.insLineTimeInfo.starttime = "";
                  this.insLineTimeInfo.endtime = "";
                  this.insLineTimeInfo.start_month_num = "";
                  this.insLineTimeInfo.end_month_num = "";
                  this.timeVisible = false;
                  return;
                }
                let po = new Object();
                po.timeId = this.insLineTimeInfo.id;
                po.startDayNum = this.insLineTimeInfo.start_day_num;
                po.endDayNum = this.insLineTimeInfo.end_day_num;
                po.startMonthNum = this.insLineTimeInfo.start_month_num;
                po.endMonthNum = this.insLineTimeInfo.end_month_num;
                po.starttime = this.insLineTimeInfo.starttime;
                po.endtime = this.insLineTimeInfo.endtime;
                arr.push(po);
                this.insLineTimeInfo.detailList = arr;
                this.insLineTimeInfo.starttime = "";
                this.insLineTimeInfo.endtime = "";
                this.timeVisible = false;
                this.insLineTimeInfo.start_day_num = "";
                this.insLineTimeInfo.end_day_num = "";
                this.insLineTimeInfo.start_month_num = "";
                this.insLineTimeInfo.end_month_num = "";
              }
            } else {
              console.log("error 1!!");
              return false;
            }
          }
        }
      );
    },
    delDetailList (scope) {
      this.insLineTimeInfo.detailList.splice(scope.$index, 1);
    },
    //编辑线路信息
    submitEditLineTime () {
      let validateFieldList = [];
      this.$refs["inslinetimeeditForm"].validateField(
        ["dateTime", "lineId", "never", "type"],
        async (errorMsg) => {
          if (!errorMsg) {
            validateFieldList.push(errorMsg);
            if (
              validateFieldList.length == 3 &&
              validateFieldList.every((item) => item === "")
            ) {
              this.insLineTimeInfo.startday = this.insLineTimeInfo.dateTime[0];
              this.insLineTimeInfo.endday = this.insLineTimeInfo.dateTime[1];
              let url = "/buss/insLineTime/addLineTime";
              if (this.insLineTimeInfo.id != null) {
                url = "/buss/insLineTime/editLineTime";
              }
              console.log("submitEditLineTime", this.insLineTimeInfo);
              this.savingEdit = true;
              this.$ajax
                .post(url, this.insLineTimeInfo)
                .then((msg) => {
                  this.savingEdit = false;
                  this.loadInsLineTimeList();
                  this.editVisible = false;
                  this.$message.success(msg);
                })
                .catch((err) => {
                  this.$message.error(err);
                  this.savingEdit = false;
                });
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        }
      );
    },
    //删除线路时间规则
    del (delId) {
      let ids = [];
      if (delId != null) {
        ids = [delId];
      } else {
        this.$refs["inslinetimeTable"].selection.forEach((ele) => {
          ids.push(ele.id);
        });
      }
      if (ids.length > 0) {
        this.loading = true;
        this.$ajax
          .post("/buss/insLineTime/deleteLineTime", { ids: ids })
          .then((msg) => {
            this.loading = false;
            this.$message.success(msg);
            this.queryObj.pageNum = 1; //删除之后，回到第一页
            this.loadInsLineTimeList();
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    selecDateAndTime () {
      let validateFieldList = [];
      this.$refs["inslinetimeeditForm"].validateField(
        ["never", "type"],
        async (errorMsg) => {
          if (!errorMsg) {
            validateFieldList.push(errorMsg);
            if (
              validateFieldList.length == 2 &&
              validateFieldList.every((item) => item === "")
            ) {
              this.timeVisible = true;
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        }
      );
    },

    handleNumChange () {

      this.options = [];
      for (let i = 0; i < this.insLineTimeInfo.never; i++) {
        const obj = {
          label: i + 1,
          value: i + 1,

        };
        this.options.push(obj);
      }
      if (this.insLineTimeInfo.detailList != null) {
        this.$set(this.insLineTimeInfo, "detailList", []);
      }
    },
    ontypeChange () {
      this.$set(this.insLineTimeInfo, "detailList", []);
      this.$set(this.insLineTimeInfo, "start_day_num", "");
      this.$set(this.insLineTimeInfo, "end_day_num", "");
      this.$set(this.insLineTimeInfo, "starttime", "");
      this.$set(this.insLineTimeInfo, "endtime", "");
      this.$set(this.insLineTimeInfo, "start_month_num", "");
      this.$set(this.insLineTimeInfo, "end_month_num", "");
      this.$refs["inslinetimeeditForm"].clearValidate(["start_day_num"]);
      this.$refs["inslinetimeeditForm"].clearValidate(["end_day_num"]);
      this.$refs["inslinetimeeditForm"].clearValidate(["start_month_num"]);
      this.$refs["inslinetimeeditForm"].clearValidate(["end_month_num"]);
      this.$refs["inslinetimeeditForm"].clearValidate(["starttime"]);
      this.$refs["inslinetimeeditForm"].clearValidate(["endtime"]);
      this.optionsday = [];
      for (let i = 0; i < 28; i++) {
        const obj = {
          label: i + 1,
          value: i + 1,
        };
        this.optionsday.push(obj);
      }
      const obj = {
        label: "月底",
        value: 32,
      };
      this.optionsday.push(obj);
    },
    getStartDayValue (val) {
      this.insLineTimeInfo.start_day_num = val;
      this.$refs["inslinetimeeditForm"].clearValidate(["start_day_num"]);
    },
    getEndDayValue (val) {
      this.insLineTimeInfo.end_day_num = val;
      this.$refs["inslinetimeeditForm"].clearValidate(["end_day_num"]);
    },
    getStartMonthValue (val) {
      this.insLineTimeInfo.start_month_num = val;
      this.$refs["inslinetimeeditForm"].clearValidate(["start_month_num"]);
    },
    getEndMonthValue (val) {
      this.insLineTimeInfo.end_month_num = val;
      this.$refs["inslinetimeeditForm"].clearValidate(["end_month_num"]);
    },
    listenMonth () {
      this.$set(this.insLineTimeInfo, "end_month_num", "");
    },
    listenDay () {
      this.$set(this.insLineTimeInfo, "end_day_num", "");
    },
  },
  mounted () {
    this.init();
    this.loadLineListAll();
  },

  computed: {
    filteredOptions () {
      if (
        this.insLineTimeInfo.start_day_num != null &&
        this.insLineTimeInfo.start_day_num != "" &&
        this.insLineTimeInfo.type == 1
      ) {
        const max = this.insLineTimeInfo.start_day_num;
        return this.options.filter((option) => option.value >= max);
      } else if (
        this.insLineTimeInfo.start_month_num != null &&
        this.insLineTimeInfo.start_month_num != ""
      ) {
        const max = this.insLineTimeInfo.start_month_num;
        return this.options.filter((option) => option.value >= max);
      } else {
        return this.options;
      }
    },
    filteredOptionsDay () {
      if (
        this.insLineTimeInfo.start_day_num != null &&
        this.insLineTimeInfo.start_day_num != ""
      ) {
        const max = this.insLineTimeInfo.start_day_num;
        return this.optionsday.filter((option) => option.value >= max);
      } else {
        return this.optionsday;
      }
    },
  },
};
</script>
<style>
.el-inslinetimeDetailTable {
  margin-left: -110px;
}

.el-select-dropdown .el-scrollbar__wrap {
  max-height: 180px;
  overflow-y: auto;
}
</style>
